import {
  GET_DEPARTMENTS,
  GET_DEPARTMENTS_SUCCESS,
  GET_DEPARTMENTS_FAIL,
  ADD_DEPARTMENTS,
  ADD_DEPARTMENTS_SUCCESS,
  ADD_DEPARTMENTS_FAIL,
  UPDATE_DEPARTMENTS,
  UPDATE_DEPARTMENTS_SUCCESS,
  UPDATE_DEPARTMENTS_FAIL,
  DELETE_DEPARTMENTS,
  DELETE_DEPARTMENTS_SUCCESS,
  DELETE_DEPARTMENTS_FAIL,
  SET_DEPARTMENT_FIELD_ERRORS,
} from './actionTypes'

// Get Departments
export const getDepartments = () => ({
  type: GET_DEPARTMENTS,
})

export const getDepartmentsSuccess = (departments) => ({
  type: GET_DEPARTMENTS_SUCCESS,
  payload: departments,
})

export const getDepartmentsFail = (error) => ({
  type: GET_DEPARTMENTS_FAIL,
  payload: error,
})

// Add Department
export const addDepartment = (department) => ({
  type: ADD_DEPARTMENTS,
  payload: department,
})

export const addDepartmentSuccess = (department) => ({
  type: ADD_DEPARTMENTS_SUCCESS,
  payload: department,
})

export const addDepartmentFail = (error) => ({
  type: ADD_DEPARTMENTS_FAIL,
  payload: error,
})

// Update Department
export const updateDepartment = (department) => ({
  type: UPDATE_DEPARTMENTS,
  payload: department,
})

export const updateDepartmentSuccess = (department) => ({
  type: UPDATE_DEPARTMENTS_SUCCESS,
  payload: department,
})

export const updateDepartmentFail = (error) => ({
  type: UPDATE_DEPARTMENTS_FAIL,
  payload: error,
})

// Delete Department
export const deleteDepartment = (id) => ({
  type: DELETE_DEPARTMENTS,
  payload: id,
})

export const deleteDepartmentSuccess = (id) => ({
  type: DELETE_DEPARTMENTS_SUCCESS,
  payload: id,
})

export const deleteDepartmentFail = (error) => ({
  type: DELETE_DEPARTMENTS_FAIL,
  payload: error,
})

// Set Field Errors
export const setDepartmentFieldErrors = (errors) => ({
  type: SET_DEPARTMENT_FIELD_ERRORS,
  payload: errors,
})
